import AttachmentsModalModule from './attachments-modal.module'

export default AttachmentsModalModule
